export default "__VITE_ASSET__CdeW4lgh__"